import React, { FunctionComponent, useMemo } from 'react';
import styled from 'styled-components';
import { ContentBox, UniverseSections } from '../../generated/contentful-generated-types';
import { isCategoryPage, isContentBox, isProductPage, isAmsProductPage, isCalculatorPage, showForUserMultiple } from '../../utils/contentful';
import { SimpleCardRow } from '../Tiles/SimpleCardRow';
import { getColorFromCode } from '../../common/constants';
import { useIsLoggedIn, useIsReseller, useIsRegisteredNonBuyer } from '../../hooks/useLogin';
import { useAlgoliaSearchByObjectIds } from '../../hooks/useAlgoliaSearchByObjectIds';
interface Props {
  section: UniverseSections;
}
export const ProductOrCategoryPage: FunctionComponent<Props> = ({ section }) => {
  const contentBoxList = section.itemsCollection?.items.filter(item => item != undefined && isContentBox(item)) as ContentBox[];

  const filteredList = contentBoxList.filter(
    item =>
      item.content != undefined &&
      (isProductPage(item.content) || isCategoryPage(item.content) || isAmsProductPage(item.content) || isCalculatorPage(item.content))
  );
  const currentUserLoggedIn = useIsLoggedIn();
  const currentUserReseller = useIsReseller();
  const currentUserRegisteredNonBuyer = useIsRegisteredNonBuyer();
  const items =
    filteredList.filter((item: ContentBox) =>
      showForUserMultiple(item.showOnlyForMultiple, currentUserReseller, currentUserLoggedIn, currentUserRegisteredNonBuyer)
    ) ?? [];
  const selectedProductsIds = filteredList?.map(item => item?.sys?.id).filter(id => id !== undefined && id !== null) as string[];

  const objectIDs = useMemo(() => (selectedProductsIds?.length > 0 ? selectedProductsIds : []), [selectedProductsIds?.join(',')]);
  const hitsPerPage = objectIDs.length;
  const hits = useAlgoliaSearchByObjectIds({ objectIDs, hitsPerPage });

  return (
    <>
      {!!filteredList.length && (
        <StyledProductOrCategoryContainer>
          <StyledProductOrCategoryPageTitle>{section.sectionTitle}</StyledProductOrCategoryPageTitle>
          <SimpleCardRow items={items} asCarousel={true} hits={hits} />
        </StyledProductOrCategoryContainer>
      )}
    </>
  );
};

const StyledProductOrCategoryPageTitle = styled.h2`
  color: ${getColorFromCode('exa black', '#323232')};
  font-family: 'Styrene Medium';
  font-size: 20px;
  font-style: normal;
  line-height: 30.54px;

  @media (max-width: 380px) {
    font-size: 16px;
    padding: 0 8px;
  }
`;
const StyledProductOrCategoryContainer = styled.div`
  width: 100%;

  margin-bottom: -32px; //to compensate the extra margin needed for shadows

  @media (max-width: 1024px) {
    padding: 0 4px;
  }
  @media (max-width: 768px) {
    padding: 0 4px;
  }
  @media (max-width: 375px) {
    margin-bottom: 0px;
  }

  .carousel-container {
    margin-top: 16px;
    padding: 0;
    @media (max-width: 380px) {
      padding: 0 8px;
    }
  }

  .simple-card {
    margin-bottom: 24px;
    @media (max-width: 768px) {
      margin-right: 4px;
    }
    @media (max-width: 380px) {
      margin-bottom: 0px;
    }
    .price-range {
      display: none;
    }
  }
  .simple-card-image {
    height: 149px;
  }

  .simple-card-title {
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;
